const React = require('react')
const PropTypes = require('prop-types')
const MarionetteControllerRegion = require('lib/marionette_controller_region')
const withStyles = require('withStyles').default
const styles = require('./viewer_panel.less')

function getViewerPanelController(callback) {
    require.ensure([], () => {
        callback(require('./viewer_panel_controller'), {
            scope: styles.scope,
        })
    }, 'viewer-panel')
}

function ViewerPanel(props, context) {

    const { mapped, is_owner } = props
    if (mapped) return false
    if (! is_owner) return false

    return (
        <MarionetteControllerRegion
            className={styles.scope}
            getController={getViewerPanelController}
            />
    )
}

ViewerPanel.propTypes = {
    mapped: PropTypes.bool.isRequired,
    is_owner: PropTypes.bool.isRequired,
}

module.exports = withStyles(styles)(ViewerPanel)
